import React, { useState } from 'react';
import InvoiceReceiptNotesController from '../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceReceiptNotesController';
import Loader from '../../../../../Components/Loader';
import Textarea from '../../../../../Components/Textaera';
import LoadingSkeleton from '../../../../../Components/LoadingSkeleton';

const InvoiceReceiptNotesScreen = ({ narrationText, notesText, loadingSettings, errorSettings, onRefresh }) => {
    const {
        narration,
        setNarration,
        notes,
        setNotes,
        handleUpdateReceiptNarration,
        loading,
        error,
        success,
        isEditing,
        setIsEditing,
        narrationError,
        notesError,
    } = InvoiceReceiptNotesController(narrationText, notesText, errorSettings, onRefresh);

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Receipt Narration & Notes</h2>

            {/* Narration Section */}
            <div style={styles.field}>
                <label style={styles.label}>Narration</label>
                {isEditing ? (
                    <Textarea
                        placeholder="Enter your narration here..."
                        value={narration}
                        onChange={(e) => { setNarration(e.target.value) }}
                        errorMessage={narrationError}
                        maxLength={450}
                        width={1000}
                    />
                ) : (
                    <div style={styles.textValue}>{loadingSettings ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{narration}</span>)}</div>
                )}
            </div>

            {/* Notes Section */}
            <div style={styles.field}>
                <label style={styles.label}>Notes</label>
                {isEditing ? (
                    <Textarea
                        placeholder="Enter your notes here..."
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        errorMessage={notesError}
                        maxLength={1000}
                        width={1000}
                    />
                ) : (
                    <div style={styles.textValue}>{loadingSettings ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{notes}</span>)}</div>
                )}
            </div>

            <hr className="footer-divider" />

            {/* Action Buttons */}
            <div className="button-container" style={{ gap: "10px" }}>
                {isEditing ? (
                    <>
                        <button className="add-client-button"
                            onClick={handleUpdateReceiptNarration}
                            style={{ paddingLeft: 30, paddingRight: 30, opacity: loading ? 0.5 : 1, cursor: loading ? 'not-allowed' : 'pointer', }} disabled={loading}>
                            <span style={{ paddingRight: loading ? 10 : 0 }}><Loader loading={loading} color={'#FFFFFF'} size='small' /></span>
                            Update
                        </button>
                        <button style={styles.cancelButton} onClick={() => { setIsEditing(false); }}>
                            Cancel
                        </button>
                    </>
                ) : (
                    <button className="add-client-button" onClick={() => setIsEditing(true)}
                        style={{ paddingLeft: 30, paddingRight: 30, opacity: loadingSettings ? 0.5 : 1, cursor: loadingSettings ? 'not-allowed' : 'pointer', }} disabled={loadingSettings}>
                        Edit
                    </button>
                )}
                {error && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {error} </div>}
                {success && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{success} </div>}
            </div>
        </div >
    );

}

const styles = {
    // container: {
    //   width: "600px",
    //   margin: "0 auto",
    //   fontFamily: "Arial, sans-serif",
    // },
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
        marginBottom: '5px'
    },
    field: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: "15px",
        gap: "10px",
        marginTop: "25px",
    },
    label: {
        flex: "0 0 200px",
        color: 'black',
        fontSize: '14px',
        fontFamily: 'Roboto',
        fontWeight: '400',
    },
    textValue: {
        flex: "1",
        fontSize: "12px",
        color: "#333",
        lineHeight: "1.5",
        color: '#192A3E',
    },
    textarea: {
        flex: "1",
        border: "1px solid #d1e3ed",
        borderRadius: "5px",
        fontSize: "14px",
        padding: "10px",
        width: "100%",
        resize: "none",
    },
    updateButton: {
        backgroundColor: "#40513B",
        color: "white",
        border: "none",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    cancelButton: {
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    }
};

export default InvoiceReceiptNotesScreen;
